/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useQuery } from "@tanstack/react-query";
import { notificarErroApi } from "utils/alertaCiencia";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

interface Props {
  idBloco?: string | null;
  enabled?: boolean;
}

/**
 * Lista as unidades elegíveis do bloco selecionado.
 *
 * O backend já descarta unidades inativas ou indisponíveis (status 4), de forma
 * que só chegam aqui unidades passíveis de ter sua proposta copiada.
 */
export function useGetUnidadesCopiaProposta(props: Props) {
  const GET_UNIDADES = `${backofficeEnviroment}/common/oportunidades-lead/copia-proposta/unidades/v1`;

  const fetchData = async () => {
    const response = await instance.get(GET_UNIDADES, {
      params: { idBloco: props.idBloco },
    });
    return response?.data?.data;
  };

  const query = useQuery({
    queryFn: fetchData,
    queryKey: ["copia-proposta-unidades", props.idBloco],
    refetchOnWindowFocus: false,
    enabled: Boolean(props.enabled && props.idBloco),
    onError: (error: any) => {
      notificarErroApi("Erro ao buscar unidades", error);
    },
  });

  return query;
}
